import { render } from "./Sda.vue?vue&type=template&id=ca72e592"
import script from "./Sda.vue?vue&type=script&lang=js"
export * from "./Sda.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__